import styles from '@styles/screens/StartDemoScreen.module.css'
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { isMobile } from 'react-device-detect';
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import designSystem from "@styles/designSystem"
import { TextAreaInput, TextInput } from '@components/General/TextInput';
import { useState, useCallback, useMemo, useEffect } from 'react';
import { NormalButton } from '@components/General/Button';
import {} from "@localization/Localization"
import { useStartDemoViewModel } from '../view-models/StartDemoScreenViewModel';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { ErrorText } from '@components/General/Texts';
import { ToastManager } from '@components/Messages/ToastManager';

export const StartDemoScreen: React.FC = () => {
    const {
        loading,
        name,
        phone,
        company,
        email,
        nameError,
        phoneError,
        companyError,
        emailError,
        serviceError,
        setLoading,
        setName,
        setPhone,
        setCompany,
        setEmail,
        validateEmail,
        validateName,
        validatePhone,
        validateCompany,
        handleSubmit,
        viewDidAppear,
    } = useStartDemoViewModel();

    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once

    return (
        <HorizontalContainer 
            gap={designSystem.gapNone}
            height={'100%'}
        >
            <VerticalContainer 
                maxWidth={'50%'} 
                height={'100%'}
            >
                <QontactLogoPanel/>
            </VerticalContainer>
            <VerticalContainer 
                maxWidth={'50%'} 
                alignment={'center'}
                backgroundColor={designSystem.colorBackgroundGray3}
            >
                <VerticalSpacer/>
                <VerticalContainer 
                    width={'600px'}
                >
                    <VerticalContainer gap={designSystem.gapNone}>
                        <H2Title text={"Experimenta Qontact".localized()}/>
                        <Subtitle text={"Ingresa tu nombre y número de teléfono para que puedas probar fichar vos mismo ahora!"}/>
                    </VerticalContainer>
                    <TextInput
                        label={"Nombre".localized()}
                        placeholder={"Ingresa tu nombre completo".localized()}
                        onChange={(e) => {setName(e)}}
                        value={name}
                        onLostFocus={validateName}
                        loading={false}
                        error={nameError}
                    />
                    <TextInput
                        label={"Email".localized()}
                        placeholder={"Ingresa tu email laboral".localized()}
                        onChange={(e) => {setEmail(e)}}
                        value={email}
                        onLostFocus={validateEmail}
                        loading={false}
                        error={emailError}
                    />
                    <TextAreaInput
                        label={"Número de teléfono".localized()}
                        placeholder={"Ingresa tu número de teléfono incluyendo el código de país, ej: +5491155557788".localized()}
                        onChange={(e) => {setPhone(e)}}
                        onLostFocus={validatePhone}
                        value={phone}
                        error={phoneError}
                    />
                    <TextInput
                        label={"Empresa".localized()}
                        placeholder={"Dónde trabajas?".localized()}
                        onChange={(e) => {setCompany(e)}}
                        onEnterPress={() => { handleSubmit() }}
                        value={company}
                        onLostFocus={validateCompany}
                        error={companyError}
                    />
                    <NormalButton 
                        text={"Siguiente".localized()}
                        width={"300px"}
                        onClick={() => {
                            handleSubmit()
                        }} 
                        loading={loading}
                    />
                    { serviceError && 
                        <ErrorText text={serviceError}/>
                    }
                </VerticalContainer>
                <VerticalSpacer/>
            </VerticalContainer>
        </HorizontalContainer>
    )
}